import { SCENE_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: SCENE_MNG,
  listUrl: `${SCENE_MNG}/sceneList`,
  relationSearch: true,
  allowStatus: {},
  sortArr: [
    {
      fieldName: 'industryId',
      direction: 'ASC'
    },
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入场景名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['sceneName'],
    hasColAdjustment: true,
    items: [],
    tips: {
      label:
        '注：本模块可以根据行业下指定的场景把场景信息、关联功能、用例全部复制到目标行业下，场景名称可自定义（不重复即可）',
      type: 'warning'
    }
  },
  view: {
    columns: [
      {
        props: {
          label: 'pocMng.industry',
          prop: 'industryId',
          width: 200
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.industryName
        },
        filter: true,
        url: `industry/list`,
        params: {
          limit: 100,
          page: 0
        }
      },
      {
        props: {
          label: '行业编码',
          prop: 'industryCode',
          width: 120
        }
      },
      {
        props: {
          label: '场景名',
          prop: 'sceneName'
        }
      },
      {
        props: {
          label: '场景编码',
          prop: 'sceneCode',
          width: 120
        }
      },
      {
        props: {
          label: '场景类型',
          prop: 'sceneType',
          sortField: 'sceneType',
          width: 120
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'sceneType'
      },
      {
        props: {
          label: '推荐产品版本',
          prop: 'recommendProduct'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '场景复制',
        command: 'SceneCopy',
        name: 'SceneCopy'
      }
    ]
  }
}
